import { render, staticRenderFns } from "./SnsCard.vue?vue&type=template&id=18210e5b&scoped=true&"
import script from "./SnsCard.vue?vue&type=script&lang=js&"
export * from "./SnsCard.vue?vue&type=script&lang=js&"
import style0 from "./SnsCard.vue?vue&type=style&index=0&id=18210e5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18210e5b",
  null
  
)

export default component.exports